export default class WebReference {
    static init(): void {
        //init class
        const webReferenceInit = document.querySelector('.js-web-reference');

        if (webReferenceInit) {
            document.querySelectorAll<HTMLElement>('.web-reference-item').forEach((item) => {
                item.addEventListener('mouseenter', function (this: HTMLElement, event: MouseEvent) {
                    if (window.innerWidth > 992) {
                        const direction = getMouseDirection(event);
                        animateIn(this, direction);
                    }
                });

                item.addEventListener('mouseleave', function (this: HTMLElement, event: MouseEvent) {
                    if (window.innerWidth > 992) {
                        const direction = getMouseDirection(event);
                        animateOut(this, direction);
                    }
                });
            });
        }

        function getMouseDirection(event: MouseEvent): string {
            const item = event.currentTarget as HTMLElement;
            const { left, top, width, height } = item.getBoundingClientRect();
            const mouseX = event.clientX - left;
            const mouseY = event.clientY - top;
            const deltaX = Math.min(Math.abs(mouseX), Math.abs(mouseX - width));
            const deltaY = Math.min(Math.abs(mouseY), Math.abs(mouseY - height));

            if (deltaX < deltaY) {
                return mouseX < width / 2 ? 'left' : 'right';
            } else {
                return mouseY < height / 2 ? 'top' : 'bottom';
            }
        }

        function getOppositeDirection(direction: string): string {
            const opposites: { [key: string]: string } = {
                left: 'right',
                right: 'left',
                top: 'bottom',
                bottom: 'top',
            };
            return opposites[direction];
        }

        function animateIn(item: HTMLElement, direction: string): void {
            const logoImg = item.querySelector<HTMLElement>('.web-reference-item__img--logo');
            const bgImg = item.querySelector<HTMLElement>(
                '.web-reference-item__img:not(.web-reference-item__img--logo)',
            );

            if (!logoImg || !bgImg) return;

            // Zajistíme správný výchozí stav
            logoImg.classList.remove('is-current');
            bgImg.classList.add('is-current');

            // Animace loga ven (opačným směrem než odkud myš přijela)
            const oppositeDirection = getOppositeDirection(direction);
            logoImg.style.transition = 'transform 0.5s';
            switch (oppositeDirection) {
                case 'left':
                    logoImg.style.transform = 'translateX(-100%)';
                    break;
                case 'right':
                    logoImg.style.transform = 'translateX(100%)';
                    break;
                case 'top':
                    logoImg.style.transform = 'translateY(-100%)';
                    break;
                case 'bottom':
                    logoImg.style.transform = 'translateY(100%)';
                    break;
            }

            // Příprava background obrázku ze směru odkud myš přijela
            bgImg.style.transition = 'none';

            switch (direction) {
                case 'left':
                    bgImg.style.transform = 'translateX(-100%)';
                    break;
                case 'right':
                    bgImg.style.transform = 'translateX(100%)';
                    break;
                case 'top':
                    bgImg.style.transform = 'translateY(-100%)';
                    break;
                case 'bottom':
                    bgImg.style.transform = 'translateY(100%)';
                    break;
            }

            // Trigger reflow
            bgImg.offsetHeight;

            // Animace background obrázku dovnitř
            setTimeout(() => {
                bgImg.style.transition = 'transform 0.5s';
                bgImg.style.transform = 'translateX(0%) translateY(0%)';
            }, 10);
        }

        function animateOut(item: HTMLElement, direction: string): void {
            const logoImg = item.querySelector<HTMLElement>('.web-reference-item__img--logo');
            const bgImg = item.querySelector<HTMLElement>(
                '.web-reference-item__img:not(.web-reference-item__img--logo)',
            );

            if (!logoImg || !bgImg) return;

            // Zajistíme správný výchozí stav
            bgImg.classList.remove('is-current');
            logoImg.classList.add('is-current');

            // Animace background obrázku ven
            bgImg.style.transition = 'transform 0.5s';
            switch (direction) {
                case 'left':
                    bgImg.style.transform = 'translateX(-100%)';
                    break;
                case 'right':
                    bgImg.style.transform = 'translateX(100%)';
                    break;
                case 'top':
                    bgImg.style.transform = 'translateY(-100%)';
                    break;
                case 'bottom':
                    bgImg.style.transform = 'translateY(100%)';
                    break;
            }

            // Příprava loga z opačného směru
            const oppositeDirection = getOppositeDirection(direction);
            logoImg.style.transition = 'none';

            switch (oppositeDirection) {
                case 'left':
                    logoImg.style.transform = 'translateX(-100%)';
                    break;
                case 'right':
                    logoImg.style.transform = 'translateX(100%)';
                    break;
                case 'top':
                    logoImg.style.transform = 'translateY(-100%)';
                    break;
                case 'bottom':
                    logoImg.style.transform = 'translateY(100%)';
                    break;
            }

            // Trigger reflow
            logoImg.offsetHeight;

            // Animace loga dovnitř z opačného směru
            setTimeout(() => {
                logoImg.style.transition = 'transform 0.5s';
                logoImg.style.transform = 'translateX(0%) translateY(0%)';
            }, 10);
        }
    }
}
